/*  ========================================================================
    # Scripts - Mobile Menu
    ========================================================================  */

/**
 * Script that handles the mobile menu toggle functionality.
 */
const MobileMenu = {
  cfg: {
    menuToggle: document.querySelector('.c-header__mobile-toggle'),
    mobileMenu: document.querySelector('.c-header__mobile'),
    states: {
      open: 'open'
    }
  },

  /**
   * Handle the toggle functionality for the mobile menu.
   * Adds or removes the 'open' class to the html tag based on the menu state
   */
  handleToggle() {
    this.cfg.menuToggle.addEventListener('click', () => {
      this.cfg.mobileMenu.classList.toggle(this.cfg.states.open);
      this.cfg.menuToggle.classList.toggle(this.cfg.states.open);
    });
  },

  handleAnchorClicks() {
    const anchors = this.cfg.mobileMenu.querySelectorAll('a[href*="#"]');

    anchors.forEach(anchor => {
      anchor.addEventListener('click', () => {
        this.cfg.mobileMenu.classList.remove(this.cfg.states.open);
        this.cfg.menuToggle.classList.remove(this.cfg.states.open);
      });
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.menuToggle) {
      this.handleToggle();
      this.handleAnchorClicks();
    }
  }
};

export default MobileMenu;
